import React from 'react'

import {
  Notice,
  Icon,
  SuccessFilled,
  Error as ErrorIcon,
  InfoOutlined,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, oneOf, func } from 'prop-types'

function Notification({ message, type, onClose: handleClose }) {
  let noticeType = 'danger'
  let iconComponent = ErrorIcon
  let iconColor = 'danger'

  if (type === 'success') {
    noticeType = 'positive'
    iconComponent = SuccessFilled
    iconColor = 'positive'
  } else if (type === 'info') {
    noticeType = 'primary'
    iconComponent = InfoOutlined
    iconColor = 'primary'
  }

  return (
    <div className="use-cases-area__notification">
      <Notice
        type={noticeType}
        onClose={handleClose}
        useSSRIcon
        ssrIcon={<Icon svgComponent={iconComponent} color={iconColor} />}
      >
        <div className="use-cases-area__notification-content">
          {message}
        </div>
      </Notice>
    </div>
  )
}

Notification.propTypes = {
  message: string.isRequired,
  onClose: func.isRequired,
  type: oneOf(['success', 'error', 'info']).isRequired,
}

export default Notification
